import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select.tsx';
import { cn } from '@/lib/utils.ts';
import React from 'react';
import { TLabelValue } from '@/types/misc.ts';

type Props = {
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: TLabelValue[];
  placeholder?: string;
  triggerClass?: string;
  none?: boolean;
} & React.ComponentProps<typeof Select>;

export function SelectInput({name, value, onChange, placeholder, triggerClass, none, options, ...props}: Props) {
  return (
    <Select name={name} value={String(value)} onValueChange={onChange} {...props}>
      <SelectTrigger data-placeholder={placeholder} className={cn('min-w-[120px]', triggerClass)}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((item) => (
          <SelectItem key={item.value} value={String(item.value)}>
            {item.label}
          </SelectItem>
        ))}
        {none && <SelectItem value="none">None</SelectItem>}
      </SelectContent>
    </Select>
  );
}